// extracted by mini-css-extract-plugin
module.exports = {"container":"playstore_container__2Yom2","container_img":"playstore_container_img__oMgI1","android":"playstore_android__2jKHT"};